module.exports = __webpack_public_path__ + "assets/img/icon-user-selected1.4e344748.png";